<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="font-weight-bold">
                                Auditoria Importação
                            </h4>
                        </div>
                        <div class="col-md-12">
                            <table
                                class="table table-bordered bg-white table-sm"
                            >
                                <tbody>
                                    <tr
                                        v-for="item in item.auditoria"
                                        :key="item.id"
                                    >
                                        <td>
                                          <b>  {{ item.value }}</b><br>
                                            <span v-if="item.type == 'usuario'">
                                             <b>NIS:</b>  {{ item.content.nis ? item.content.nis :'' }}<br>
                                             <b>Nascimento:</b>  {{ item.content.nascimento | formatDate }}<br>
                                             <b>Situação prioritária:</b>  {{ item.content.priority }}<br>
                                            </span>
                                        </td>
                                        <td v-if="item.type == 'unidade'">
                                         <span class="text-danger"> A unidade {{ item.value }} não está
                                            cadastrada.</span>
                                        </td>
                                        <td v-else>
                                          <span class="text-danger">O usuário não foi vinculado por não
                                            está cadastrado no sistema ou excluído.</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    name: "Encaminhamentos",
    metaInfo() {
        return {
            title: this.$i18n.t("Auditoria"),
        };
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
